import React from 'react'

const goalsandarchives = () => {
  return (
    <div>
      Goals And Archives
    </div>
  )
}

export default goalsandarchives
